<template>
    <section v-if="message"
             :class="`message-display message-display--${validType}`">
        <i v-if="hasIcon" :class="icon" />
        <span :class="`message-display__text ${hasIcon ? 'message-display__text--with-icon' : ''}`">{{ message }}</span>
    </section>
    <section v-else-if="hasSlot"
             :class="`message-display message-display--${validType}`">
        <i v-if="hasIcon" :class="icon" />
        <span :class="`message-display__text ${hasIcon ? 'message-display__text--with-icon' : ''}`">
            <slot />
        </span>
    </section>
</template>

<script>

export default {

    props: {
        message: {
            type: String,
            default: null,
        },
        type: {
            type: String,
            default: 'default',
        },
    },

    computed: {
        hasIcon() {
            return this.icon && this.icon.length
        },

        hasSlot() {
            return this.$slots.default
        },

        icon() {
            switch (this.validType) {
                case 'affirm':
                case 'ok':
                    return 'far fa-check-circle'
                case 'error':
                    return 'fas fa-exclamation-triangle'
                case 'warning':
                    return 'fas fa-exclamation-circle'
                case 'info':
                    return 'fas fa-info-circle'
                default:
                    return ''
            }
        },

        validType() {
            return this.type.toLowerCase()
        },
    },

    beforeMount() {
        const validTypes = [ 'info', 'affirm', 'error', 'warning', 'ok', 'default' ]
        if (!validTypes.includes(this.validType))
            throw new TypeError(`The prop 'type' is invalid. Please provide one of ${ validTypes.join(', ') }`)
    },
}

</script>

<style lang="scss">

// Ensure colours and other visual style elements are added to theme files, not placed in here.
// src\scss\schemes\components\global\_hh-msg-display.scss

.message-display {
    margin-bottom: 10px;

    @include element('text') {

        @include modifier('with-icon') {
            padding-left: 10px;
        }
    }

    @include modifier('info') {
        color: $info;
    }

    @include modifiers('affirm' 'ok') {
        color: $success;
    }

    @include modifier('warning') {
        color: $warning;
    }

    @include modifier('error') {
        color: $error;
    }
}

</style>
